import { render, staticRenderFns } from "./PushNotifications.vue?vue&type=template&id=00d751ce&scoped=true"
import script from "./PushNotifications.vue?vue&type=script&lang=ts"
export * from "./PushNotifications.vue?vue&type=script&lang=ts"
import style0 from "./PushNotifications.vue?vue&type=style&index=0&id=00d751ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d751ce",
  null
  
)

export default component.exports